import { Redirect } from 'expo-router'
import { FormattedMessage } from 'react-intl'
import { FlatList } from 'react-native'

import { PublicationPlaceholders } from '@/src/features/community/ui/screens/CommunityScreen/PublicationsPlaceholders'
import { FeedItemPlaceholder } from '@/src/features/prayer-space/ui/screens/PrayerSpaceScreen/components/FeedItemPlaceholder'
import { EmptyState } from '@/src/general/components/EmptyState'
import { ErrorMessage } from '@/src/general/components/ErrorMessage'
import { ICON } from '@/src/general/enums/icons'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

import { useFavoritePublicationsQuery } from '../../services/useFavoritePublicationsQuery'
import { PublicationCard } from '../components/PublicationCard'
import { PublicationSeed } from '../components/PublicationSeed/PublicationSeed'

const ListEmptyComponent = () => (
  <EmptyState
    icon={ICON.BOOKMARK_X}
    title={<FormattedMessage id="publication.favorite.none.now" />}
    description={<FormattedMessage id="publication.favorite.how-to" />}
  />
)

export const FavoritePublicationsScreen = () => {
  const { data, fetchNextPage, isFetchingNextPage, error } = useFavoritePublicationsQuery()

  const { routes } = useRoutes()

  if (data && data.length < 3) return <Redirect href={routes.settings()} />

  if (error) return <ErrorMessage error={error} defaultErrorKey="publication.load.error" />

  return (
    <FlatList
      className="w-full"
      data={data}
      keyExtractor={(item) => `${item.id}`}
      contentContainerClassName="mx-auto flex w-full flex-col gap-4 justify-between pb-32 max-w-[700px]"
      renderItem={({ item }) => (
        <PublicationSeed initialPublicationId={item.publication.id}>
          {({ data: publicationSeed }) => (
            <PublicationCard
              publication={{
                ...(publicationSeed ?? item.publication),
                hasPrayed: false,
                community: {
                  ...item.publication.community,
                  isAdmin: false,
                  isAnimator: false,
                  isCreator: false,
                  hasJoined: false,
                },
              }}
              trackingSource={TRACKING_SOURCE.USER_FAVORITES_PAGE}
              publicationTrackingSource={PUBLICATION_TRACKING_SOURCE.USER_FAVORITES_PAGE}
            />
          )}
        </PublicationSeed>
      )}
      initialNumToRender={10}
      ListFooterComponent={() => isFetchingNextPage && !!data && <FeedItemPlaceholder />}
      onEndReached={() => {
        if (!isFetchingNextPage) fetchNextPage()
      }}
      ListEmptyComponent={data ? ListEmptyComponent : PublicationPlaceholders}
    />
  )
}
